<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from '@/composables/useToast';

const toast = useToast();
const { t, te } = useI18n();

function classFor(type) {
  return {
    success: 'bg-green-600',
    error: 'bg-red-600',
    info: 'bg-blue-600',
    warning: 'bg-yellow-600',
  }[type];
}

function label(item) {
  return te(item.messageKey) ? t(item.messageKey, item.params) : item.messageKey;
}

const items = computed(() => toast.items);
</script>

<template>
  <div class="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
    <transition-group name="toast">
      <div
        v-for="item in items"
        :key="item.id"
        :class="['flex items-start justify-between gap-3 rounded-md px-4 py-3 text-sm text-white shadow-lg', classFor(item.type)]"
      >
        <span class="flex-1">{{ label(item) }}</span>
        <button
          class="text-white opacity-80 hover:opacity-100"
          type="button"
          @click="toast.dismiss(item.id)"
        >
          ✕
        </button>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
